<template>
  <div class="row survey w-100 m-auto" :key="'question_' + question.uuid">
    <div class="my-5 d-flex align-items-center justify-content-between p-0">
      <Loading v-if="creatingResponseGroup"></Loading>
      <label class="px-5 cursor-pointer d-flex flex-grow-1 align-items-center" @click="toggleExpand">
        <i class="fad fa-angle-right fs-2x" v-if="!expanded"></i>
        <i class="fad fa-angle-down fs-2x" v-else></i>
        <div class="fs-2x fw-bolder ms-3 mb-0 d-flex align-items-center flex-grow-1">
          {{ question.label }}
          <span
            v-if="firstRg"
            class="badge ms-3 fs-7"
            :class="isComplete ? 'badge-light-success' : 'badge-light-warning'"
          >
            <i class="fad me-1" :class="isComplete ? 'fa-check-circle' : 'fa-exclamation-circle'"></i>
            {{ isComplete ? trans('Complet') : (firstRg.state || 0) + '%' }}
          </span>
          <i v-if="loading" class="fad fa-spinner-third spin ms-3 text-muted fs-5"></i>
        </div>
      </label>
    </div>

    <template v-if="expanded">
      <template v-for="(rg, index) in question.response.responseGroups">
        <div class="d-flex align-items-center" :key="'header_' + rg.uuid" v-if="question.max > 1">
          <h2 class="m-0">
            <template v-if="rg.alias">
              {{ rg.alias }}
            </template>
            <template v-else>
              {{ question.label }} N°{{ index + 1 }}
            </template>
          </h2>
        </div>
        <ResponseGroupManager :key="'rgKey_' + rg.uuid" :melted="melted" :name="'rg_' + rg.uuid" :uuid="rg.uuid" />
      </template>
    </template>
  </div>
</template>
<script lang="ts">
import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import Question from "@/entity/Question";
import { api } from "@/services/Api";
import ResponseGroup from "@/entity/ResponseGroup";
import Response from "@/entity/Response";
import Loading from "@/components/Loading.vue";
import Popup from "@/entity/Popup";
import { rgBatchLoader } from "@/services/RgBatchLoader";

@Component({
  name: 'SurveyType',
  components: { Loading }
})
export default class SurveyType extends Vue {
  [x: string]: any;

  @Prop() question!: Question
  @Prop() melted?: boolean
  @Inject('comparatorContext') comparatorContext!: () => { rg: ResponseGroup; branch: any; form: any }

  get responseGroup(): ResponseGroup { return this.comparatorContext().rg }

  creatingResponseGroup = false
  rg: any = null
  branch = ''
  slug = ''
  spin = 'off'
  expanded = false
  loading = false

  get firstRg(): any {
    return this.question?.response?.responseGroups?.[0] || null;
  }

  get isComplete(): boolean {
    return ((this.firstRg?.state ?? 0) >= 100);
  }

  async mounted() {
    if (this.question.response.responseGroups.length === 0) {
      this.createSubResponseGroup()
    }
  }

  async toggleExpand() {
    this.expanded = !this.expanded;
    if (!this.expanded) return;
    // Lazy-load les stubs si pas encore hydrates (stubs sans responses).
    const pending = (this.question.response.responseGroups || []).filter((r: any) => {
      return !Array.isArray(r.responses) || r.responses.length === 0;
    });
    if (pending.length === 0) return;
    this.loading = true;
    try {
      await Promise.all(pending.map((r: any) => rgBatchLoader.loadRg(r.uuid)));
    } finally {
      this.loading = false;
    }
  }

  async createSubResponseGroup() {
    if (this.question.max) {
      if (this.question.response.responseGroups.length >= this.question.max!) {
        new Popup('Erreur', 'Vous avez atteint le nombre maximum autorisé', 'danger')
        return;
      }
    }
    this.creatingResponseGroup = true
    const data = { rgUuid: this.responseGroup.uuid, questionUuid: this.question.uuid }
    api.createSubGroup(data, (res: any) => {
      this.creatingResponseGroup = false
      if (res && res.data && res.data.responses) {
        res.data.responses.forEach((d: any) => {
          const r = d.response;
          if (d.questionUuid === this.question.uuid && d.responseGroupUuid === this.responseGroup.uuid) {
            const index = this.question.response.responseGroups.findIndex((rg: ResponseGroup) => {
              return rg.uuid === r.uuid
            })
            if (index === -1) {
              const occ = new ResponseGroup(r);
              // Passe par le formStore pour garantir la reactivite
              // (question.response est une prop dynamique non observee).
              this.$store.commit('formStore/ADD_SUB_RG', {
                rgUuid: this.responseGroup.uuid,
                questionId: this.question.id,
                subRg: r,
              });
              this.$store.commit('appendRg', occ)
              this.question.updateAnswer();
              this.$store.commit('responseSaved')
            }
          }
        })
      }
    })
  }


  async load() {
    this.spin = 'on'
    const res = await api.get(api.form, 'question/get/survey/linked/' + this.question.uuid)
    if (res && res.data && res.data.survey) {
      this.branch = res.data.survey.branch
      this.slug = res.data.survey.slug
    }
    this.spin = 'off'
  }

}
</script>
<style scoped>
</style>
